<script lang="ts">import Action from '../Action/Action.svelte';
const { variant = 'button', colorMode, size = 'regular', disabled = false, href = '#', altText = '', target, rel, balanced = false, onClick = () => { }, modal, noArrow = false, preventOrphanIcon = false, text = '', class: className = '', ...rest } = $props();
</script>

<Action
  {...rest}
  as="a"
  class="Link {className}"
  {variant}
  {colorMode}
  {size}
  {disabled}
  {href}
  {altText}
  {target}
  {rel}
  {balanced}
  {onClick}
  {modal}
  {noArrow}
  {preventOrphanIcon}
  {text}
/>
